import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

const useIsTabletScreen = () => {
  const theme = useTheme();

  return {
    states: {
      isTablet: useMediaQuery(theme.breakpoints.down('lg')), // TODO change for screensize, doesn't seem to be really tablet https://plusgrade.jira.com/browse/FE-437
    },
  };
};

export default useIsTabletScreen;
